if (!customElements.get('dt-product-benefits')) {
  customElements.define('dt-product-benefits', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.onOpen = (event) => {
        if (!event.target.closest('[data-dt-fsa-open]')) return;
        event.preventDefault();
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      };
      this.onDialogClick = (event) => {
        if (event.target.closest('[data-dt-fsa-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.onClose = () => { document.documentElement.style.overflow = this.previousOverflow || ''; };
      this.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onClose);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onOpen);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onClose);
      if (this.dialog?.open) this.onClose();
    }
  });
}
